import * as api from './adapter';

// The DAX-mirrored port-call schedule of one vessel (DAX-84).
//
// Plain JSON, not JSON:API — the backend endpoint is shaped like
// `select_options`, and for the same reason: one read-only feed for one form
// control. It answers TWO questions in a single request, which is what the crew
// change form needs in create mode where it holds nothing but a vessel id:
//
//   daxManaged — is this vessel part of the DAX-managed fleet (`dax_vessels`)?
//   portCalls  — its schedule, nearest-first, already flattened.
//
// `daxManaged: false` is a normal answer. Most of the fleet this system serves
// is not enrolled in DAX, and the picker stays out of the way for those.
export default {
  /**
   * A vessel's mirrored schedule.
   * @param {Object} params
   * @param {Number|String} params.vesselId - Crewisor vessel id
   * @returns {Promise<{daxManaged: Boolean, portCalls: Array}>}
   */
  index: async ({ vesselId }) => {
    const { data } = await api.read('dax_port_calls', {
      query: { vessel_id: vesselId },
    });

    return {
      daxManaged: !!data?.daxManaged,
      portCalls: data?.portCalls || [],
    };
  },
};
